// Add future applications here. A product with landingPageUrl opens its own site;
// otherwise the shared /products/:slug page renders its details.
export const products = [
  {
    slug: 'statementsync',
    name: 'StatementSync',
    category: 'Finance & Productivity',
    status: 'live',
    featured: true,
    tagline: 'Convert PDF bank statements into clean Excel or CSV.',
    description: 'Turn PDF bank statements into organised, spreadsheet-ready transaction data without repetitive manual entry.',
    landingPageUrl: 'https://statementsync.bpasolutions.au/',
    ctaLabel: 'Explore StatementSync',
    benefits: [
      'Convert PDF bank statements into usable data',
      'Export transactions to Excel or CSV',
      'Save time on manual transaction entry'
    ],
    images: [
      {
        url: 'https://cloud.sharemyimage.com/2026/10/02/StatementSync-Pro-1.png',
        alt: 'StatementSync software product preview'
      },
      {
        url: 'https://cloud.sharemyimage.com/2026/10/02/StatementSync-Pro-2.png',
        alt: 'Additional StatementSync software preview'
      },
      {
        url: 'https://cloud.sharemyimage.com/2026/10/02/StatementSync-2.png',
        alt: 'StatementSync application screenshot'
      },
      {
        url: 'https://cloud.sharemyimage.com/2026/10/02/StatementSync-1.png',
        alt: 'StatementSync interface screenshot'
      },
      {
        url: 'https://cloud.sharemyimage.com/2026/10/02/statementsync_smarter_bank_statement_analysis.png',
        alt: 'StatementSync smarter bank statement analysis preview'
      }
    ]
  }
];

export const publishedProducts = products.filter(product => product.status !== 'hidden');